function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "von-gradient-twitch",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "rgba(221,79,152,1)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "rgba(179,71,144,1)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "rgba(120,60,134,1)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "90%",
  stopColor: "rgba(85,53,128,1)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "rgba(38,44,120,1)"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#von-gradient-twitch)",
  d: "M9.97 18.492l2.03-2.03h3.821l2.388-2.388v-7.641h-11.463v10.03h3.224v2.029zm4.418-9.313h1.433v4.175h-1.433v-4.175zm-3.821 0h1.433v4.175h-1.433v-4.175zm8.433-9.179h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm.642 14.791l-4.179 4.179h-3.104l-2.031 2.03h-2.149v-2.03h-3.821v-11.224l1.075-2.746h14.209v9.791z"
});

var SvgTwitch = function SvgTwitch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitch.1c4d3947.svg";
export { ForwardRef as ReactComponent };